module.exports = __webpack_public_path__ + "img/internet-explorer.6904c86e.svg";